import React from 'react';
import { transactions as types } from '../../../../../../types';
import { Root, ColStyled, RowStyled } from './styled';

const PulsaInfo = ({ curData }: { curData: types.TTransactions }) => {
    return (
        <Root>
            <RowStyled>
                <ColStyled>
                    <span>User</span>
                    <span>{curData.nexId}</span>
                </ColStyled>
            </RowStyled>
            <RowStyled>
                <ColStyled>
                    <span>Phone number</span>
                    <span>{curData.meta.phone}</span>
                </ColStyled>
            </RowStyled>
            {/*<RowStyled>
                <ColStyled>
                    <span>Denomination</span>
                    <span></span>
                </ColStyled>
            </RowStyled>*/}
        </Root>
    );
};

export default PulsaInfo;
